import React from 'react';

const TimesheetsEmployee = () => {
    return (
        <div className="timesheet-container" style={{ fontFamily: 'Arial, sans-serif' }}>
            <div className="content-section">
                <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                    Define the process of filling Timesheet?
                </h3>
                <p className="description">
                Timesheets are essential tools for tracking employee work hours, ensuring accurate payroll, and maintaining compliance with labor regulations." 
                </p>
                
                <h6 className="section-heading">What This Guide Covers</h6>
                <ul className="list">
                    <li>Best practices for submitting timesheets on time.</li>
                    <li>How to effectively communicate for timesheet approvals.</li>
                    <li>Common mistakes in timesheet management and how to avoid them.</li>
                </ul>

                <p className="closing-text">
                    Whether you're an employee submitting timesheets or a manager approving them, understanding the process ensures efficiency and compliance. Follow these guidelines to stay organized!
                </p>
                
                <img 
                    src="https://res.cloudinary.com/danfpnuui/image/upload/v1737352184/Time_sheets_-2_oku8qr.png" 
                    alt="Timesheet Management" 
                    className="placeholder-image image_gatnix_support"
                />

                <h3 className="sub-heading">Filling Out Time Sheets</h3>
                <h4>Step 1: Click the Time Sheet if you are logged in.</h4>
                <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737352184/timesheet_step1.png" alt="Step 1" className="step-image" />
                
                <h4>Step 2: Select the Project if you have time sheets.</h4>
                <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737352184/timesheet_step2.png" alt="Step 2" className="step-image" />
                
                <h4>Step 3: Click the sheet to see the weekly time sheet.</h4>
                <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737352184/timesheet_step3.png" alt="Step 3" className="step-image" />
                
                <p>Note: Enter your billable hours for each day within 24 hours, and you can also enter non-billable hours. If you save the time sheet, it will be marked as pending.</p>

                <h4>Tip:</h4>
                <p>If you submit the time sheet without an attachment, the super admin or approval manager may reject it. Attachments such as screenshots, PDFs, and Excel sheets should be uploaded.</p>
                
                <h3 className="sub-heading">Uploading Attachments</h3>
                <h4>Step 1: Select the time sheets.</h4>
                <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737352184/upload_step1.png" alt="Upload Step 1" className="step-image" />
                
                <h4>Step 2: Click the project and choose the sheet to which you want to add an attachment.</h4>
                <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737352184/upload_step2.png" alt="Upload Step 2" className="step-image" />
                
                <h4>Step 3: Open the sheet and upload your attachments.</h4>
                <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1737352184/upload_step3.png" alt="Upload Step 3" className="step-image" />
                
                <p>Note: You can drag and drop files for upload. Only screenshots, PDFs, and Excel sheets are allowed.</p>

                <h4>Tip:</h4>
                <p>Click on 'Upload Attachments,' select the file, and confirm the upload. Once submitted, you will receive a confirmation email.</p>
            </div>
        </div>
    );
};

export default TimesheetsEmployee;
